export default __webpack_public_path__ + "static/media/ponto-de-vendas-tela-meio-de-um-cupom-1212x646-800x426.f1dfe887.png";